/**
 * 拍单新订单数量ws封装
 * created by 李智惠 2022-10-30
*/

import Bus from '@/utils/bus'; // 中央事件总线

let heartbeatTimer = null; // 心跳定时器
let serverTimeoutTimer = null; // 服务器超时断连定时器
let disconnectTimer = null; // 断开 重连倒计时
let lockReconnect = false; // 是否真正建立连接
let _this = null; // 转移this指向

//进入页面初始化websocket连接
function initWebSocketTakeOrder() {
  // 参数处理
  if (_this == null) _this = this;
  // 判断页面有没有存在websocket连接
  if (_this.$store.state.wsTakeOrder == null) {
    if (window.WebSocket) {
      // const wsUrl = `ws://8.133.165.236:80/ws?type=3&deptId=${_this.deptId}`;
      const wsUrl = `wss://www.xinglinct.com/ws?type=3&deptId=${_this.deptId}`; //正式
      // const wsUrl = `wss://test.xinglinct.com/ws?type=3&deptId=${_this.deptId}`; //测试
      _this.$store.state.wsTakeOrder = new WebSocket(wsUrl); // 创建长链接
      _this.$store.state.wsTakeOrder.onopen = webSocketOnOpen; // 连接成功
      _this.$store.state.wsTakeOrder.onerror = webSocketOnError; // 连接错误
      _this.$store.state.wsTakeOrder.onmessage = webSocketOnMessage; // 接收信息
      _this.$store.state.wsTakeOrder.onclose = webSocketOnClose; // 连接关闭
    }
  } else {
    _this.$store.state.wsTakeOrder = null;
    initWebSocketTakeOrder();
  }
}
// 连接成功事件
function webSocketOnOpen() {
  heartbeatStart(); // 开启心跳
}

// 连接错误事件
function webSocketOnError() {
  reconnect(); // 重新连接
}

// 接收信息事件
function webSocketOnMessage(e) {
  let newOrderNum = _this.$session.get('newOrderNum');
  let content = JSON.parse(e.data).data.content;
  if (content && content == '有新的拍单') {
    newOrderNum ++;
    _this.$session.set('newOrderNum', newOrderNum);
    Bus.$emit('newOrderNumBack', newOrderNum);
  }
  reset(); // 收到服务器信息，心跳重置
}

// 连接关闭事件
function webSocketOnClose() {
  reconnect();
}

// 连接失败重新连接
function reconnect() {
  if (lockReconnect) return;
  lockReconnect = true;
  disconnectTimer && clearTimeout(disconnectTimer);
  disconnectTimer = setTimeout(function () {
    initWebSocketTakeOrder();
    lockReconnect = false;
  }, 6000);
}

// 重置心跳
function reset(){
  clearTimeout(heartbeatTimer); // 清除心跳定时器
  clearTimeout(serverTimeoutTimer); // 清除服务器超时断连定时器
  heartbeatStart(); // 重启心跳
}

// 开启心跳
function heartbeatStart() {
  heartbeatTimer && clearTimeout(heartbeatTimer);
  serverTimeoutTimer && clearTimeout(serverTimeoutTimer);
  heartbeatTimer = setTimeout(() => {
    //这里发送一个心跳，后端收到后，返回一个心跳消息
    if (_this.$store.state.wsTakeOrder.readyState == 1) _this.$store.state.wsTakeOrder.send("heartCheck"); // 如果连接正常
    else reconnect(); // 重新连接
    serverTimeoutTimer = setTimeout(() => {
      _this.$store.state.wsTakeOrder.close();
    }, 30000);
  }, 30000);
}

export default initWebSocketTakeOrder;